import { render } from "./LandingFormDetails.vue?vue&type=template&id=33325ffd&scoped=true&ts=true&lang=pug"
import script from "./LandingFormDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandingFormDetails.vue?vue&type=script&lang=ts&setup=true"

import "./LandingFormDetails.vue?vue&type=style&index=0&id=33325ffd&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33325ffd"]])

export default __exports__